import React, { useState } from "react";
import { Dropdown, Input, Nav, Navbar } from "rsuite";
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";
import * as userManager from "../../Services/UserSessionManager";
import { Link, useNavigate } from "react-router-dom";
import { ProfileDropDown } from "./ProfileDropDown";
import "./Home.css";

export const AdminReport = () => {
  const [checkRole, setCheckRole] = useState(userManager.GetUserRole());

  const [navBar, setNavBar] = useState([]);

  const handleChange = (event: any) => {
    setNavBar(event.target.innerText);
  };

  return (
    <>
      {checkRole == "H" ? (
        <Dropdown
          title={"Report"}
          className="nav-bar-text-white"
          icon={
            <BootstrapIcon
              cssClasses="p-2 nav-bar-text-white"
              bootStrapIconName="file-earmark-fill"
              size={18}
            />
          }
        >
          {/* <Link className="link-simple" to={"/AttritionDetails"}>
            <Dropdown.Item
              icon={
                <BootstrapIcon
                  bootStrapIconName={"person-x-fill"}
                  size={14}
                  cssClasses={"pe-2"}
                />
              }
            >
              Attrition Report
            </Dropdown.Item>
          </Link> */}

          <Link className="link-simple" to={"/AttritionDetailsBI"}>
            <Dropdown.Item
              icon={
                <BootstrapIcon
                  bootStrapIconName={"person-x-fill"}
                  size={14}
                  cssClasses={"pe-2"}
                />
              }
            >
              Attrition Report BI
            </Dropdown.Item>
          </Link>
        </Dropdown>
      ) : (
        <></>
      )}

      {checkRole == "A" ? (
        <Dropdown
          title={"Report"}
          className="nav-bar-text-white"
          icon={
            <BootstrapIcon
              cssClasses="p-2 nav-bar-text-white"
              bootStrapIconName="file-earmark-fill"
              size={18}
            />
          }
        >
          {/* <Link className="link-simple" to={"/AttritionDetails"}>
            <Dropdown.Item
              icon={
                <BootstrapIcon
                  bootStrapIconName={"person-x-fill"}
                  size={14}
                  cssClasses={"pe-2"}
                />
              }
            >
              Attrition Report
            </Dropdown.Item>
          </Link> */}

          <Link className="link-simple" to={"/AttritionDetailsBI"}>
            <Dropdown.Item
              icon={
                <BootstrapIcon
                  bootStrapIconName={"person-x-fill"}
                  size={14}
                  cssClasses={"pe-2"}
                />
              }
            >
              Attrition Report BI
            </Dropdown.Item>
          </Link>
          <Link className="link-simple" to={"/ExpectionsOrRejectionsBI"}>
            <Dropdown.Item
              icon={
                <BootstrapIcon
                  bootStrapIconName={"person-x-fill"}
                  size={14}
                  cssClasses={"pe-2"}
                />
              }
            >
              Exceptions BI Report
            </Dropdown.Item>
          </Link>
          <Link className="link-simple" to={"/RejectionsBI"}>
            <Dropdown.Item
              icon={
                <BootstrapIcon
                  bootStrapIconName={"person-x-fill"}
                  size={14}
                  cssClasses={"pe-2"}
                />
              }
            >
              Rejections BI Report
            </Dropdown.Item>
          </Link>
        </Dropdown>
      ) : (
        <></>
      )}

      {checkRole == "BI" ? (
        <Dropdown
          title={"Report"}
          className="nav-bar-text-white"
          icon={
            <BootstrapIcon
              cssClasses="p-2 nav-bar-text-white"
              bootStrapIconName="file-earmark-fill"
              size={18}
            />
          }
        >
          <Link className="link-simple" to={"/ExpectionsOrRejectionsBI"}>
            <Dropdown.Item
              icon={
                <BootstrapIcon
                  bootStrapIconName={"person-x-fill"}
                  size={14}
                  cssClasses={"pe-2"}
                />
              }
            >
              Exceptions BI Report
            </Dropdown.Item>
          </Link>
          <Link className="link-simple" to={"/RejectionsBI"}>
            <Dropdown.Item
              icon={
                <BootstrapIcon
                  bootStrapIconName={"person-x-fill"}
                  size={14}
                  cssClasses={"pe-2"}
                />
              }
            >
              Rejections BI Report
            </Dropdown.Item>
          </Link>
        </Dropdown>
      ) : (
        <></>
      )}
    </>
  );
};
